//export const API_URL = "http://localhost:8091/";
//export const API_URL = "https://api.fiqueokonline.com.br/";
export const API_URL = "https://api.fiqueokonline.seuapoio0800.com.br/";